// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"97cc9ecf","65":"465da79b","138":"f26ddbe5","149":"d2beaa24","277":"770c04e9","339":"82fd6e75","396":"6f660f38","528":"326d2345","713":"b08d752f","759":"56cbe07f","799":"64f646c0","911":"8491eec3","951":"5c22c461","968":"b3287992","980":"997bac93"}[chunkId] + ".chunk.js";
};